module.exports = __webpack_public_path__ + "static/media/photo-slide-2.15e408e6.jpg";